import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import { Button } from '@material-ui/core';
import { changePassword } from '../redux/changePassword.action';
import FormInput from '../../../shared/component/formInput';
import Loader from '../../../shared/component/loader';
import { doNotification, closeNotification } from '../../../shared/component/notifier';

class ChangePassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            formData: {
                password: '',
                confirmPassword: '',
                oldPassword: '',
            },
            formErrors: {},
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidUpdate(prevProps) {
        const { enqueueSnackbar, closeSnackbar, errorLoad, successLoad, closeDialog, onSuccess } = this.props;

        if (successLoad && prevProps.successLoad !== successLoad) {
            closeDialog();
            this.notify = doNotification(enqueueSnackbar, closeSnackbar, successLoad, 'success');
            if (onSuccess)  onSuccess();
        }

        if (errorLoad && prevProps.errorLoad !== errorLoad) {
            this.notify = doNotification(enqueueSnackbar, closeSnackbar, errorLoad, 'error');
        }
    }

    handleChange(event) {
        const { isLoading } = this.props;

        if (isLoading) {
            return;
        }
        const { formData, formErrors } = this.state;
        const {name, value} = event.target;
        formData[name] = value;
        delete formErrors[name];
        this.setState({ formData, formErrors });
    }

    handleSubmit(event) {
        event.preventDefault();
        const { closeSnackbar, changePassword } = this.props;
        const { formData } = this.state;
        const isValid = this.isValid(['password', 'confirmPassword', 'oldPassword']);

        if (!isValid) {
            return;
        }
        this.notify = closeNotification(this.notify, closeSnackbar);
        changePassword(formData);
    }

    isValid(fields) {
        let { formData, formErrors } = this.state;
        formErrors = {};

        for (const field of fields) {
            if (field === 'oldPassword') {
                !formData[field] && (formErrors[field] = 'Old password is required');
            }

            if (field === 'password') {
                !formData[field] && (formErrors[field] = 'Password is required');
            }

            if (field === 'confirmPassword') {
                !formData[field] && (formErrors[field] = 'Confirm password');
                formData[field] && (formData['password'] !== formData['confirmPassword']) && (formErrors[field] = 'Passwords do not match')
            }
        }
        this.setState({ formErrors });
        return Object.keys(formErrors).length === 0;
    }

    render() {
        const { formData, formErrors } = this.state;
        const { isLoading } = this.props;

        return (
            <React.Fragment>
                <Loader active={isLoading} dim={true}/>

                <div className="dialog_form_root">
                    <form noValidate autoComplete="off">
                        <FormInput
                            required
                            error={formErrors['oldPassword'] ? true : false}
                            helperText={formErrors['oldPassword']}
                            type="password"
                            value={formData.oldPassword}
                            name="oldPassword"
                            label="Old password"
                            onChange={this.handleChange}
                        />

                        <FormInput
                            required
                            error={formErrors['password'] ? true : false}
                            helperText={formErrors['password']}
                            type="password"
                            value={formData.password}
                            name="password"
                            label="Password"
                            onChange={this.handleChange}
                        />

                        <FormInput
                            required
                            error={formErrors['confirmPassword'] ? true : false}
                            helperText={formErrors['confirmPassword']}
                            type="password"
                            value={formData.confirmPassword}
                            name="confirmPassword"
                            label="Confirm Password"
                            onChange={this.handleChange}
                        />

                        <Button variant="contained" className="btn dark_blue_btn form_btn" onClick={this.handleSubmit}>
                            Save Changes
                        </Button>
                    </form>
                </div>
            </React.Fragment>
        )
    }
}

function mapStateToProps({ rxAccount }) {
    const { rxChangePassword } = rxAccount;

    return {
        isLoading: rxChangePassword.changePassLoading,
        errorLoad: rxChangePassword.changePassError,
        successLoad: rxChangePassword.changePassSuccess,
    }
}

ChangePassword.propTypes = {
    isLoading: PropTypes.bool,
    errorLoad: PropTypes.string,
    successLoad: PropTypes.string,
    onSuccess: PropTypes.func,
    closeDialog: PropTypes.func,
    enqueueSnackbar: PropTypes.any,
    closeSnackbar: PropTypes.any,
    changePassword: PropTypes.func,
}

export default connect(mapStateToProps, {
    changePassword,
})(withSnackbar(ChangePassword));
